/**
 * /dashboard/travel-preapprovals/new — Submit a new travel pre-approval
 * (G15 frontend; POST /api/v1/travel-preapprovals).
 *
 * Available to ANY authenticated tenant user — the backend does NOT
 * gate creation by role; everyone who can travel for work can request
 * a pre-approval. Approve/Reject is the role-gated half.
 *
 * The TravelPreapprovalForm owns the post-create redirect to the
 * detail route (via useNavigate inside the form).
 */

import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/shared/page-header";
import { TravelPreapprovalForm } from "@/components/travel/travel-preapproval-form";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/travel-preapprovals/new",
)({
  component: NewTravelPreapprovalRoute,
});

function NewTravelPreapprovalRoute() {
  // Top-of-page Back button removed per Audit 4 Quick-Win #4 — the
  // bottom Cancel handles it.
  return (
    <>
      <PageHeader
        title="New travel pre-approval"
        description="Get a budget cap signed off before you book a trip. Your manager (or HR) decides."
      />
      <Card className="max-w-2xl">
        <CardContent className="pt-6">
          <TravelPreapprovalForm />
        </CardContent>
      </Card>
    </>
  );
}
